module.exports = __webpack_public_path__ + "images/花筑pr长图_04-1.jpg?v=01e62a11";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_04-1.jpg
 ** module id = 14
 ** module chunks = 1 2
 **/